module.exports = __webpack_public_path__ + "static/sportovni-odpoledne-na-czu-aed157c480a0012761b3789122ff70cf.jpg";